import { jsx as _jsx } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
import { isInternalFileUrl } from "../../urlUtils";
import { prop } from "../template";
const style = css("color: inherit;");
export const LinkRenderer = ({ className, values, href, children, transformUrl, ...props }) => {
    let link = prop(values, href, href);
    // Convert to string and apply transformUrl if needed
    if (typeof link === "string") {
        if (transformUrl && isInternalFileUrl(link)) {
            link = transformUrl(link);
        }
    }
    else if (link && typeof link === "object" && "url" in link) {
        // Extract URL from FileReference object
        link = link.url;
    }
    else {
        // Fallback to href for non-string values
        link = href;
    }
    return (_jsx("a", { ...props, href: link, className: cx(className, style), target: "_blank", rel: "noopener noreferrer", children: children }));
};
